import React from 'react';
import { Box, IconButton, styled } from '@mui/material';
import { YouTube, Instagram, Facebook, Twitter } from "@mui/icons-material";

const SocialButton = styled(IconButton)(({ theme }) => ({
    display: 'inline-block',
    position: 'relative',
    cursor: 'pointer',
    width: '2.5rem',
    height: '2.5rem',
    // border: '0.125rem solid transparent',
    padding: 0,
    textDecoration: 'none',
    textAlign: 'center',
    fontSize: '1.25rem',
    fontWeight: 'normal',
    lineHeight: '2em',
    borderRadius: '10%',
    transition: 'all 0.5s ease',
    marginRight: '0.25rem',
    marginBottom: '0.25rem',
    backgroundColor: '#d0d8db',
    // backgroundColor: '#555',
    '&:hover': {
        transform: 'scale(1.1)',
        backgroundColor: '#fefefe',
        borderColor: 'currentcolor',
    },
    '&:last-child': {
        marginRight: 0,
    },
    color: 'inherit',
}));

const TwitterIcon = styled(Twitter)({
    color: '#55acee',
    '&:hover': {
        color: '#55acee',
        backgroundColor: '#fefefe',
    },
});

const InstagramIcon = styled(Instagram)({
    color: 'rgb(144, 81, 202)',
    '&:hover': {
        color: '#125688',
    },
});

const FacebookIcon = styled(Facebook)({
    '&:hover': {
        color: '#3b5998',
    },
});

const YouTubeIcon = styled(YouTube)({
    color: '#bb0000',
    '&:hover': {
        color: 'tomato',
    },
});

// const LinkedInIcon = styled(LinkedIn)({
//     '&:hover': {
//         color: '#007bb5',
//     },
// });

const SocialMediaIcons = () => {
    return (
        <Box sx={{
            display: 'flex',
            // justifyContent: 'center',
            // alignItems: 'center',
            gap: 1,
            mt: 2
        }}>
            <SocialButton href="https://www.twitter.com/" target="_blank" rel="noopener noreferrer">
                <TwitterIcon />
            </SocialButton>
            <SocialButton href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">
                <FacebookIcon />
            </SocialButton>
            <SocialButton href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
                <InstagramIcon />
            </SocialButton>
            <SocialButton href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">
                <YouTubeIcon />
            </SocialButton>
            {/* <SocialButton href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">
                <LinkedInIcon />
            </SocialButton> */}
        </Box>
    );
};

export default SocialMediaIcons;



// import React from 'react';
// import { Box, IconButton } from '@mui/material';
// import { YouTube, Instagram, Facebook, LinkedIn } from "@mui/icons-material";

// const socialMediaStyles = {
//     socialButton: {
//         display: 'inline-block',
//         position: 'relative',
//         cursor: 'pointer',
//         width: '3.125rem',
//         height: '3.125rem',
//         border: '0.125rem solid transparent',
//         padding: 0,
//         textDecoration: 'none',
//         textAlign: 'center',
//         fontSize: '1.5625rem',
//         fontWeight: 'normal',
//         lineHeight: '2em',
//         borderRadius: '1.6875rem',
//         transition: 'all 0.5s ease',
//         marginRight: '0.25rem',
//         marginBottom: '0.25rem',
//         bgcolor: '#d0d8db',
//         color: 'inherit',
//         '&:hover': {
//             transform: 'scale(1.1)',
//             bgcolor: '#fefefe',
//             border: '0.125rem solid',
//         },
//         // More styles...
//     },
//     facebookSvgIcon: {
//         '&:hover': { color: '#3b5998', borderColor: '#3b5998' },
//     },
//     linkedinSvgIcon: {
//         '&:hover': { color: '#007bb5', borderColor: '#007bb5' },
//     },
//     youtubeSvgIcon: {
//         color: '#bb0000',
//         '&:hover': { color: 'tomato', borderColor: '#bb0000' },
//     },
//     instagramSvgIcon: {
//         color: 'rgb(144, 81, 202)',
//         '&:hover': { color: '#125688', borderColor: '#125688' },
//     },
// };

// const SocialMediaIcons = () => {
//     return (
//         <Box sx={{ display: 'flex', justifyContent: 'space-evenly', alignItems: 'center' }}>
//             <IconButton href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" sx={{ ...socialMediaStyles.socialButton, ...socialMediaStyles.instagramSvgIcon }}>
//                 <Instagram />
//             </IconButton>
//             <IconButton href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer" sx={{ ...socialMediaStyles.socialButton, ...socialMediaStyles.facebookSvgIcon }}>
//                 <Facebook />
//             </IconButton>
//             <IconButton href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" sx={{ ...socialMediaStyles.socialButton, ...socialMediaStyles.youtubeSvgIcon }}>
//                 <YouTube />
//             </IconButton>
//             <IconButton href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer" sx={{ ...socialMediaStyles.socialButton, ...socialMediaStyles.linkedinSvgIcon }}>
//                 <LinkedIn />
//             </IconButton>
//         </Box>
//     );
// };

// export default SocialMediaIcons;
